<template>
  <div class="h-screen" :class="[`bg-${$route.meta.background}`]">
    <transition name="page" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ContactLayout',
};
</script>
